import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";

const APPEARANCE_OPTIONS = [
    { value: "system", label: "System" },
    { value: "light", label: "Light" },
    { value: "dark", label: "Dark" },
];

const General = () => {
    const [appearance, setAppearance] = useState(() => {
        return localStorage.getItem("theme-preference") || "system";
    });
    const [showAppearance, setShowAppearance] = useState(false);

    useEffect(() => {
        const root = window.document.documentElement;
        
        const applyTheme = (theme) => {
            let themeToSet = theme;

            if (theme === "system") {
                const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches 
                    ? "dark" 
                    : "light";
                themeToSet = systemTheme;
            }

            root.setAttribute("data-theme", themeToSet);
            localStorage.setItem("theme-preference", theme);
        };

        applyTheme(appearance);

        if (appearance === "system") {
            const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
            const handleChange = () => applyTheme("system");
            
            mediaQuery.addEventListener("change", handleChange);
            return () => mediaQuery.removeEventListener("change", handleChange);
        }
    }, [appearance]);

    const selectedAppearance =
        APPEARANCE_OPTIONS.find((opt) => opt.value === appearance)?.label ||
        "Select";

    return (
        <div className="settings_modal_content_item">
            <div className="settings_modal_row">
                <label className="settings_modal_row_label">Appearance</label>

                <Dropdown
                    show={showAppearance}
                    onToggle={(isOpen) => setShowAppearance(isOpen)}
                >
                    <Dropdown.Toggle
                        as="button"
                        type="button"
                        className="dropdown-settings-toggle"
                    >
                        <div>{selectedAppearance}</div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="dropdown-settings">
                        <div className="dropdown_container fade-in">
                            {APPEARANCE_OPTIONS.map((option) => (
                                <button
                                    key={option.value}
                                    type="button"
                                    className={`settings_link ${appearance === option.value ? 'active' : ''}`}
                                    onClick={() => {
                                        setAppearance(option.value);
                                        setShowAppearance(false);
                                    }}
                                >
                                    {option.label}
                                </button>
                            ))}
                        </div>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
    );
};

export default General;